export default __webpack_public_path__ + "static/media/price-high-active.ee1562c0.svg";